import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {NgbDateParserFormatter} from '@ng-bootstrap/ng-bootstrap';
import {NgbDateCustomParserFormatter} from '../../../../shared/Services/NgbDateCustomParserFormatter';
import { BackOfficeInvoiceService } from 'src/app/back-office/Services/invoice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Helper } from 'src/app/helpers/helper.service';
import { TranslateService } from '@ngx-translate/core';
// @ts-ignore
import { IButton } from 'src/app/shared/card/card.component';
import {DraftInvoiceStatusType} from '../../../../shared/enums/draft-invoice-status.enum';
import { InvoiceType } from '../../../../shared/enums/invoice-type.enum';
@Component({
  providers: [
    {provide: NgbDateParserFormatter, useClass: NgbDateCustomParserFormatter}
  ],
  selector: 'app-backoffice-draft-invoice-view',
  templateUrl: './backoffice-draft-invoice-view.component.html',
  styleUrls: ['./backoffice-draft-invoice-view.component.scss']
})
export class BackofficeDraftInvoiceViewComponent implements OnInit {

  draftInvoiceId: number;
  draftInvoiceLogId: number;
  pageTitle = '';
  draftStatus = DraftInvoiceStatusType;
  isCreditInvoice = false;
  headerContent: string;
  invoice: any;
  public specialButtonArray;
  public specialButton: IButton[] = [];
  showActionButtons = false;
  isApprovingDraft = false;

  @ViewChild('editCustomInvoiceModal', {static: false}) editCustomInvoiceModal = null;
  @ViewChild('approveModal', {static: false}) approveModal = null;
  @ViewChild('rejectModal', {static: false}) rejectModal = null;

  constructor(
    private readonly invoiceService: BackOfficeInvoiceService,
    private readonly route: ActivatedRoute,
    private readonly translator: TranslateService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.setDraftInvoiceId();
    this.setActionButtons();
  }

  private setDraftInvoiceId(): void {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.draftInvoiceId = params['id'];
      }
      if (Helper.isDefined(params['logId'])) {
        this.draftInvoiceLogId = params['logId'];
      }
      this.getDraftInvoice();
    });
  }

  private setActionButtons(): void {
    this.specialButtonArray = this.pageSpecialButtons();

    this.specialButtonArray.forEach(items => {
      this.specialButton.push({
        key: items.key,
        btnName: items.name,
        btnUrl: items.btnUrl,
        method: items.method,
        btnCustomClass: items.customClass
      });
    });
  }

  callFunction(method: string): void {
    this[method]();
  }

  approveDraftInvoice(): void {
    this.isApprovingDraft = false;
    this.approveModal.show();
  }

  rejectDraftInvoice(): void {
    this.rejectModal.show();
  }

  editDraftInvoice(): void {
    this.editCustomInvoiceModal.showDialog();
  }

  getDraftInvoice(): void {
    this.invoiceService.getDraft(this.draftInvoiceId, this.draftInvoiceLogId).subscribe((resp) => {
      this.invoice = resp;
      if ( this.invoice.type === InvoiceType.Custom) {
        this.pageTitle = this.translator.instant('doctrine.backoffice.invoice.draft_custom');
      } else {
        this.pageTitle = this.translator.instant('doctrine.backoffice.invoice.draft_credit');
        this.isCreditInvoice = true;
      }
      const statusClass =
      this.invoice?.status === this.draftStatus.Rejected
        ? 'text-danger'
        : this.invoice?.status === this.draftStatus.Approve
        ? 'text-success'
        : '';
      this.headerContent = `<div class="ms-3">${this.invoice?.mockInvoice?.invoiceDealer?.companyName} - <span class="${statusClass} text-capitalize"> ${this.invoice?.status} </<span></div>`;
      this.showActionButtons = DraftInvoiceStatusType.Draft === this.invoice?.status;
    });
  }

  getSubtotal(items: any[]): number {
    return items?.reduce((sum, item) => sum + (+item.amount * +item.price), 0);
  }

  onInvoiceEdited(event): void {
    if (event) { this.getDraftInvoice(); }
  }

  approveDraft(): void {
    if (this.isApprovingDraft) {
      return;
    }
    this.isApprovingDraft = true;
    this.invoiceService.approveDraftInvoice(this.draftInvoiceId).subscribe({
      next: () => {
        this.approveModal.hide();
        this.router.navigateByUrl('back-office/invoice/overview');
      },
      error: () => {
        this.isApprovingDraft = false;
      },
    });
  }

  rejectDraft() {
    this.invoiceService.rejectDraftInvoice(this.draftInvoiceId).subscribe(res => {
      this.rejectModal.hide();
      this.router.navigateByUrl('back-office/invoice/draft/overview');
    });
  }
  navigateToLastestVersion(): void {
    this.router.navigateByUrl('back-office/invoice/draft/show/' + this.draftInvoiceId);
  }

  private pageSpecialButtons() {
    if (this.draftInvoiceLogId) {
      return [
        { key: 'go-to', name: this.translator.instant('doctrine.backoffice.invoice.go-to'), method: 'navigateToLastestVersion', customClass: 'btn-primary' },
      ];
    } else {
      return [
        {
          key: 'reject',
          name: this.translator.instant('doctrine.backoffice.invoice.draft_reject'),
          method: 'rejectDraftInvoice',
          customClass: 'btn-grey'
        },
        {
          key: 'edit',
          name: this.translator.instant('global.edit'),
          method: 'editDraftInvoice',
          customClass: 'btn-grey'
        },
        {
          key: 'approve',
          name: this.translator.instant('doctrine.backoffice.invoice.draft_approve'),
          method: 'approveDraftInvoice',
          customClass: 'btn-primary'
        },
      ];
    }
  }
}
